/* eslint-disable import/prefer-default-export */

export function objectDirtyChecker(oldValue: any, newValue: any) {
  return JSON.stringify(oldValue) !== JSON.stringify(newValue);
}
